import Icon from '../components/Icon.vue'

Icon.register({
  'trash-restore': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M53.2 467l-21.2-339h384l-21.2 339c-1.6 24.8-23 45-47.9 45h-245.8c-24.9 0-46.3-20.2-47.9-45zM123.3 291.2c-10.1 10.6-2.9 28.8 11.3 28.8h57.4v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-112h57.4c14.3 0 21.4-18.2 11.3-28.8l-89.4-94.3c-2.5-2.7-7.6-4.9-11.3-4.9s-8.8 2.2-11.3 4.9zM432 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h120l9.4-18.7c3.6-7.3 13.1-13.3 21.3-13.3h0.1 114.3 0c8.2 0 17.8 6 21.5 13.3l9.4 18.7h120z'
      }
    ]
  }
})
